import React from 'react';
import { FontAwesomeIcon } from '../../../CommonComponents/AssetsHelper';
import { Button } from 'react-bootstrap';

function AppsMoreTopBar({ title, HideAppsMore }) {
    return (
        <div className="f-between border-bottom page_custom_header overflow-hidden">
            <div className="d-flex align-items-center flex-nowrap">
                <Button variant='link' className="p-3 border-end me-4" onClick={HideAppsMore}>
                    <FontAwesomeIcon type={'solid'} icon={'chevron-left'} iconClass=""/>
                </Button>
                <h5 className="m-0 text-nowrap overflow-hidden">{title}</h5>
            </div>
            <Button variant='link' onClick={HideAppsMore} className="p-3">
                <FontAwesomeIcon type={'solid'} icon={'xmark'} iconClass=""/>
            </Button>
        </div>
    )
}

export default AppsMoreTopBar